import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as actions from './authentication.actions';
import {
    switchMap,
    catchError,
    map,
} from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';
import { of, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthenticationState } from './authentication.reducers';
import {CurrentUserService} from "../../core/services/auth/current-user.service";
import {User} from "../../core/models/user-model";
import * as influencerActions from "../../store/influencer/influencer.actions";



@Injectable()
export class AuthenticationEffects {
  constructor(
    private actions$: Actions,
    public router: Router,
    private service: AuthenticationService,
    private store: Store<AuthenticationState>,
    private _currentUserService: CurrentUserService,
  ) {}


  loginFacebookToken$ = createEffect(() => this.actions$.pipe(
      ofType(actions.loginFacebookToken),
      switchMap( action => {
          return this.service.loginFacebookToken(action.facebookToken).pipe(
              map(instagramAccounts => {
                  return actions.loginFacebookTokenSuccess({ instagramAccounts }); }),
              catchError(error => of(actions.loginFacebookTokenFail({ error })))
          );
      })
  ));

    saveFacebookToken$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.saveFacebookToken),
            switchMap(action => {
                return of(actions.saveFacebookTokenSuccess({ facebookToken: action.facebookToken }));
            }),
        )
    );

    getCognitoCredentials$ = createEffect(() => this.actions$.pipe(
        ofType(actions.getCognitoCredentials),
        switchMap( action => {
                return this.service.getCognitoCredentials(action.instagramAccount).pipe(
                    map(credentials => {
                        this.router.navigate(['/app/profile/']);
                        // @ts-ignore
                        this._currentUserService.setUser(new User(credentials.body.SecretKey, credentials.body.SessionToken, credentials.body.Expiration, credentials.body.AccessKeyId));
                        this.store.dispatch(influencerActions.getInfluencerAvatar());
                        return actions.getCognitoCredentialsSuccess({ user: credentials.body }); }),
                    catchError(error => of(actions.getCognitoCredentialsFail({ error })))
                );
            }
        )
    ));

    loginInstagramCode$ = createEffect(() => this.actions$.pipe(
        ofType(actions.loginInstagramCode),
        switchMap(action => {
            return this.service.loginInstagramCode(action.code, action.state).pipe(
                switchMap(result => {
                    // Opt-in outcome without accounts: redirect immediately (no Cognito).
                    if (result.redirectUrl && result.accounts.length === 0) {
                        window.location.replace(result.redirectUrl);
                        return of(actions.loginInstagramRedirect({ redirectUrl: result.redirectUrl }));
                    }

                    const account = result.accounts[0];

                    if (!account || !account.instagram_id) {
                        return throwError({ status: 404, message: 'Instagram account not found' });
                    }

                    const redirectUrl = result.redirectUrl;

                    return this.service.getInstagramCognitoCredentials(account.instagram_id).pipe(
                        map(credentials => {
                            // @ts-ignore
                            this._currentUserService.setUser(new User(credentials.body.SecretKey, credentials.body.SessionToken, credentials.body.Expiration, credentials.body.AccessKeyId));
                            this.store.dispatch(influencerActions.getInfluencerAvatar());

                            // Cognito ok + Influencity return: leave 11posts.
                            if (redirectUrl) {
                                window.location.replace(redirectUrl);
                                return actions.loginInstagramRedirect({ redirectUrl });
                            }

                            this.router.navigate(['/app/profile/']);
                            return actions.loginInstagramCodeSuccess({ user: credentials.body });
                        }),
                    );
                }),
                catchError(error => of(actions.loginInstagramCodeFail({ error }))),
            );
        }),
    ));

    loginInstagramMetaError$ = createEffect(() => this.actions$.pipe(
        ofType(actions.loginInstagramMetaError),
        switchMap(action => {
            return this.service.loginInstagramMetaError(action.error, action.state).pipe(
                map(result => {
                    if (result.redirectUrl) {
                        window.location.replace(result.redirectUrl);
                        return actions.loginInstagramRedirect({ redirectUrl: result.redirectUrl });
                    }

                    return actions.loginInstagramCodeFail({
                        error: { status: 400, message: 'Login was cancelled.' },
                    });
                }),
                catchError(error => of(actions.loginInstagramCodeFail({ error }))),
            );
        }),
    ));

}
